// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import '../lib/flexible'
import store from '../utils/store';

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import 'swiper/swiper-bundle.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(VueQuillEditor)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入全局css
import './assets/scss/style.scss';
import VueMeta from 'vue-meta'
//
// import vThrottleClick from '../utils/vThrottleClick';
// // 注册全局自定义指令 `v-throttle-click`
// Vue.directive('throttle-click', vThrottleClick);


Vue.use(VueMeta)
Vue.use(Vuex) // 启用Vuex插件

Vue.config.productionTip = false

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js